import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ModuleRegistry } from '@ag-grid-community/core';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { getEnvVariables } from 'common/utils/envUtils';
import { AgGridProvider } from 'common/providers/AgGridProvider';
import { initializeDataDog } from './setupDataDog';
import queryClient from './remote-state/queryClient';
import App from './containers/App';
import { store, persistor } from './store/store';
import Theme from './features/theme';

if (process.env.NODE_ENV !== 'development') {
  initializeDataDog();
}
const root = createRoot(document.getElementById('root'));

ModuleRegistry.registerModules([ServerSideRowModelModule]);
LicenseManager.setLicenseKey(getEnvVariables().REACT_APP_AG_GRID_KEY);

root.render(
  <Provider store={store}>
    <AgGridProvider>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          <Theme>
            <CssBaseline />
              <App />
          </Theme>
        </QueryClientProvider>
      </PersistGate>
    </AgGridProvider>
  </Provider>,
);
